export enum PaymentProviders {
  PAYSTACK = "PAYSTACK",
}
